//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
//------------------------------------------------------------------------------
// API -------------------------------------------------------------------------
import client from '@api/client';
import { FaSpinner } from 'react-icons/fa';
import { StoreConfigContext } from '@helpers/storeConfigContext';

//------------------------------------------------------------------------------
// Endpoints -------------------------------------------------------------------
const Endpoints = {
  StoreConfig: {
    url: '/store-config',
    headers: {
      'gateway-api-key': import.meta.env.VITE_GATEWAY_API_KEY,
    },
  },
};
//------------------------------------------------------------------------------
// React Classes ---------------------------------------------------------------
export class StoreConfigProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingConfig: true,
    };
  }

  async componentDidMount() {
    try {
      const { data: config } = await client.get(Endpoints.StoreConfig.url, {
        headers: Endpoints.StoreConfig.headers,
      });
      config.storeConfig.currencySymbol = decodeURIComponent(
        config.storeConfig.currencySymbol
      );
      this.setState({
        config,
        loadingConfig: false,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        loadingConfig: false,
        config: {
          featureFlags: {},
          storeConfig: {},
        },
      });
    }
  }

  render() {
    const loading = this.state.loadingConfig;

    if (loading) {
      return (
        <FaSpinner
          style={{
            position: 'absolute',
            transform: 'translate(-50%,-50%)',
            top: '20%',
            left: '50%',
            animation: 'spin 1500ms linear infinite',
          }}
        />
      );
    }

    return (
      <StoreConfigContext.Provider value={this.state.config}>
        {this.props.children}
      </StoreConfigContext.Provider>
    );
  }
}
